import {Container} from "inversify";

export function defineRegulation(container: Container) {
    //obsolete function
    //moved to : boot.ts -> createRegulation()
}
